import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ShieldIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const LichtenSmokenPage = () => {
  return <main data-id="element-919">
      <SEO title="Lichten Smoken Almere | Koplampen & Achterlichten | BKCustoms" description="Professioneel lichten smoken in Almere vanaf €130. Geef uw auto een sportieve look met getinte koplampen en achterlichten. Behoud van lichtsterkte gegarandeerd." canonical="/diensten/lichten-smoken" data-id="element-920" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-921">
        <div className="absolute inset-0 overflow-hidden" data-id="element-922">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-923"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7Sz73Ji6DM6jfsjFgLE8Pn/G22-CSL-Red-768x511.webp" alt="Lichten smoken in Almere" className="w-full h-full object-cover object-center" data-id="element-924" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-925">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-926">
            <span className="text-[#D6281F]" data-id="element-927">Lichten Smoken Almere</span> - Voor
            een sportieve look
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-928">
            Geef uw auto in Almere een unieke, krachtige look met professioneel
            getinte lichten terwijl de originele lichtsterkte behouden blijft.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-929">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-930">
              <span className="mr-2" data-id="element-931">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-932" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-933">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-934">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-935">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-936">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-937">
              <div className="relative" data-id="element-938">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-939"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-940">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7Sz73Ji6DM6jfsjFgLE8Pn/G22-CSL-Red-768x511.webp" alt="Professioneel lichten smoken in Almere" className="w-full h-auto object-cover" data-id="element-941" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-942">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-943">
                Lichten Smoken Almere - Vanaf €130
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-944">
                Lichten smoken is een populaire styling techniek waarbij de
                koplampen en achterlichten van uw auto worden voorzien van een
                lichte tot medium tint, wat resulteert in een sportievere en
                meer onderscheidende uitstraling.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-945">
                Bij BKCustoms in Almere gebruiken we hoogwaardige folie die
                speciaal is ontworpen voor autolichten, waardoor de
                lichtopbrengst minimaal wordt beïnvloed terwijl het uiterlijk
                aanzienlijk verbetert.
              </p>
              <div className="space-y-4 mb-8" data-id="element-946">
                <div className="flex items-center" data-id="element-947">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-948">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-949" />
                  </div>
                  <span className="text-white/90" data-id="element-950">
                    Professionele installatie in Almere
                  </span>
                </div>
                <div className="flex items-center" data-id="element-951">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-952">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-953" />
                  </div>
                  <span className="text-white/90" data-id="element-954">Hoogwaardige materialen</span>
                </div>
                <div className="flex items-center" data-id="element-955">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-956">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-957" />
                  </div>
                  <span className="text-white/90" data-id="element-958">
                    Behoud van optimale lichtsterkte
                  </span>
                </div>
                <div className="flex items-center" data-id="element-959">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-960">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-961" />
                  </div>
                  <span className="text-white/90" data-id="element-962">
                    Verschillende tint-opties beschikbaar
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-963">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-964">
                  <span className="mr-2" data-id="element-965">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-966" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-967">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* What We Offer Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-968">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-969">
          <div className="text-center mb-16" data-id="element-970">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-971">
              Lichten Smoken in <span className="text-[#D6281F]" data-id="element-972">Almere</span>
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-973">
              Bij BKCustoms in Almere kunnen we diverse lichten van uw auto
              professioneel smoken
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-974">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-975">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-976">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-977" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-978">
                Achterlichten
              </h3>
              <p className="text-white/80" data-id="element-979">
                Geef uw achterlichten een sportieve, getinte look die uw auto
                een agressievere uitstraling geeft zonder de zichtbaarheid te
                compromitteren.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-980">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-981">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-982" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-983">Koplampen</h3>
              <p className="text-white/80" data-id="element-984">
                Subtiel getinte koplampen voor een unieke look die uw auto
                onderscheidt van de massa, met behoud van optimale lichtsterkte.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-985">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-986">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-987" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-988">Mistlampen</h3>
              <p className="text-white/80" data-id="element-989">
                Completeer de look met getinte mistlampen die perfect aansluiten
                bij de stijl van uw getinte kop- en achterlichten.
              </p>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-990">
            <p className="text-white/70 text-lg" data-id="element-991">
              Lichten smoken in Almere vanaf €130, afhankelijk van het type auto
              en de hoeveelheid lichten.
              <br data-id="element-992" />
              Neem contact met ons op voor een persoonlijke offerte.
            </p>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-993">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-994">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-995">
            Klaar voor een sportievere look met lichten smoken in Almere?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-996">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-997">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-998">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-999">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};